/* MOST desktop sorting. Preserve Shopify filters and preview query parameters. */
(function(){
  if(window.__mostDesktopSortBound)return;
  window.__mostDesktopSortBound=true;
  document.addEventListener('change',function(event){
    var select=event.target.closest && event.target.closest('#CollectionSidebarFiltersForm .most-desktop-sort-select');
    if(!select || !window.matchMedia('(min-width: 801px)').matches)return;
    event.stopImmediatePropagation();
    var target=new URL(window.location.href);
    target.searchParams.set('sort_by',select.value);
    target.searchParams.delete('page');
    window.location.assign(target.toString());
  },true);
})();
